export default __webpack_public_path__ + "static/media/sun.2f591eb7.svg";